import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["displayExpr", "valueExpr", "options", "formControlLabelProps"];
import FormControlLabel from '@mui/material/FormControlLabel';
import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
export var FormRadios = function (props) {
    var _a = props.displayExpr, displayExpr = _a === void 0 ? 'Name' : _a, _b = props.valueExpr, valueExpr = _b === void 0 ? 'id' : _b, options = props.options, formControlLabelProps = props.formControlLabelProps, others = _objectWithoutProperties(props, _excluded);
    return /*#__PURE__*/ React.createElement(RadioGroup, others, options === null || options === void 0 ? void 0 : options.map(function (item) { /*#__PURE__*/ return React.createElement(FormControlLabel, _extends({
        key: item === null || item === void 0 ? void 0 : item[valueExpr],
        value: item === null || item === void 0 ? void 0 : item[valueExpr],
        control: /*#__PURE__*/ React.createElement(Radio, null),
        label: item === null || item === void 0 ? void 0 : item[displayExpr]
    }, formControlLabelProps)); }));
};
